import { render, staticRenderFns } from "./MobileSrc.vue?vue&type=template&id=cf963eaa&scoped=true"
import script from "./MobileSrc.vue?vue&type=script&lang=js"
export * from "./MobileSrc.vue?vue&type=script&lang=js"
import style0 from "./MobileSrc.vue?vue&type=style&index=0&id=cf963eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf963eaa",
  null
  
)

export default component.exports